import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import getClassNames from 'src/common/utils/getClassNames';
import Icon from 'src/common/components/IconDS22';
import classNames from 'classnames';
import { trackEvent } from 'src/common/3rdParty/tracking';
import { GA_EVENT_FILTER } from 'src/common/gaEvents';
import styles from './CaptainFilter.module.scss';

export type CaptainFilterProps = {
  value?: 'true' | 'false';
  onChange: (value: 'true' | 'false') => void;
  onClear: () => void;
};

const GA_PARAM_CAPTAIN_OPTION = 'p2';

const captainOptionsMap = {
  true: 'Captain yes',
  false: 'Captain no',
  clear: 'Captain null',
};

const CaptainFilter: FC<CaptainFilterProps> = ({ value, onChange, onClear }) => {
  const [t] = useTranslation('search-page');
  const onFilterClick = (newValue: 'true' | 'false') => {
    onChange(newValue);
    trackEvent(GA_EVENT_FILTER, {
      [GA_PARAM_CAPTAIN_OPTION]: captainOptionsMap[newValue],
    });
  };
  const onClearClick = () => {
    onClear();
    trackEvent(GA_EVENT_FILTER, {
      [GA_PARAM_CAPTAIN_OPTION]: captainOptionsMap.clear,
    });
  };
  return (
    <div className={styles.root}>
      <button
        type="button"
        className={getClassNames(styles, 'captainOption', classNames({ isSelected: value === 'true' }))}
        onClick={() => onFilterClick('true')}
        aria-label={t('captain-filter-aria-label--provided')}
      >
        <Icon
          id="with-captain"
          size="xl"
          alt={t('captain-filter-aria-label--provided')}
          className={styles.icon}
          data-test="captain-yes"
        />
        <p className={styles.optionLabel}>{t('captain-filter-option-label--yes')}</p>
      </button>
      <button
        type="button"
        className={getClassNames(styles, 'captainOption', classNames({ isSelected: value === 'false' }))}
        onClick={() => onFilterClick('false')}
        aria-label={t('captain-filter-aria-label--not-provided')}
      >
        <Icon
          id="no-captain"
          size="xl"
          alt={t('captain-filter-aria-label--not-provided')}
          className={styles.icon}
          data-test="captain-no"
        />
        <p className={styles.optionLabel}>{t('captain-filter-option-label--no')}</p>
      </button>
      <button
        type="button"
        className={getClassNames(styles, 'clearCaptain', classNames({ isSelected: value }))}
        onClick={onClearClick}
        disabled={!value}
      >
        {t('captain-filter-clear')}
      </button>
    </div>
  );
};

export default CaptainFilter;
